import React from 'react'

const References = ({ data, onDelete }: any) => {

    if (data?.length <= 0) return null;

    return (
        <div className="review-jobs__table">
            {/* Table header */}
            <div className="review-jobs__table-header">
                <span>Full name</span>
                <span>Email</span>
                <span>PhoneNumber</span>
                <span>Action</span>
            </div>

            <hr className="review-jobs__divider" />

            {/* Table rows */}
            {data?.map((job: any, idx: any) => (
                <div key={job.id} className="review-jobs__row">
                    <span className="review-jobs__cell">{job?.reference_name}</span>
                    <span className="review-jobs__cell">{job?.reference_email}</span>
                    <span className="review-jobs__cell">{job?.reference_mobile_number}</span>
                    <button type='button' onClick={() => onDelete(job, idx)} className="review-jobs__reference_delete">Delete</button>
                </div>
            ))}

            <hr className="review-jobs__divider" />
        </div>
    )
}

export default References